'use client';

import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';

import { zendesk } from '@flipster/features/src/shared/zendesk/url';
import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import { NoSSR } from '@flipster/react/misc/lifecycle/NoSSR';
import { css } from '@flipster/styled-system/css';
import { hstack, vstack } from '@flipster/styled-system/patterns';

import { Footer } from '@web/app/_layout/footer';

import NotFoundIcon from './404.svg';

const NotFound = () => {
  const t = useTranslations();
  const router = useRouter();

  return (
    <>
      <main className={vstack({ h: 'minHeightWithoutNavigation', justify: 'center' })}>
        <NotFoundIcon className={css({ w: { base: 184, tablet: 254 }, mb: { base: 32, tablet: 80 } })} />
        <h1 className={css({ textStyle: 'Display/L', color: 'content.default.level-5', mb: 16 })}>
          <FormattedMessage id='Autogen_common.r251126.s_Whoops' />
        </h1>
        <div
          className={css({
            textStyle: 'Text/L/Regular',
            color: 'content.default.level-2',
            textAlign: 'center',
          })}
        >
          <p>
            <FormattedMessage id='Autogen_common.r251126.s_Sorry_we_could_not_find_what_you_are_looking_for' />
          </p>
          <p>
            <FormattedMessage id='Autogen_common.r251126.s_Please_check_your_URL' />
          </p>
        </div>
        <NoSSR>
          <Button
            hierarchy='primary'
            color='accent'
            size='large'
            as='a'
            href={zendesk.getUrl('RequestNew')}
            newTab
            label={t('Autogen_common.r251126.s_Contact_us_for_support')}
            css={{ display: { tablet: 'none' }, mt: 30 }}
          />
        </NoSSR>
        <div className={hstack({ display: { base: 'none', tablet: 'flex' }, mt: 60, gap: 8 })}>
          <Button
            hierarchy='secondary'
            color='neutral'
            size='large'
            onClick={() => router.back()}
            label={t('Autogen_common.r251126.s_Go_back')}
            css={{ w: 200 }}
          />
          <Button
            hierarchy='secondary'
            color='neutral'
            size='large'
            onClick={() => router.refresh()}
            label={t('Autogen_common.r251126.s_Refresh')}
            css={{ w: 200 }}
          />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default NotFound;
